import React from 'react';

export const SpotlightTopLeft: React.FC = () => (
  <svg className='tour-spotlight tour-spotlight-top-left' xmlns='http://www.w3.org/2000/svg' width='291' height='326' viewBox='0 0 291 326' fill='none'>
    <g filter='url(#filter0_f_topleft)'>
      <path
        d='M69.5626 -242.115L217.432 -94.2452L65.4008 -14.38L-12.6867 63.7075L-123.653 307.685L-326 105.338L-73.5324 2.86176L4.55509 -75.2258L69.5626 -242.115Z'
        fill='url(#paint0_linear_topleft)'
      />
    </g>
    <g filter='url(#filter1_f_topleft)' style={{ mixBlendMode: 'plus-lighter' }}>
      <path
        d='M126.768 -208.57L202.537 -132.801L34.9658 -28.9608L-48.4495 54.4545L-123.655 193.39L-199.423 117.621L-61.5382 36.3859L19.3871 -44.5394L126.768 -208.57Z'
        fill='#D9D9D9'
      />
    </g>
    <defs>
      <filter id='filter0_f_topleft' x='-426.057' y='-342.171' width='743.546' height='749.913' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='50.0284' result='effect1_foregroundBlur_topleft' />
      </filter>
      <filter id='filter1_f_topleft' x='-271.464' y='-280.611' width='546.042' height='546.042' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='36.0205' result='effect1_foregroundBlur_topleft' />
      </filter>
      <linearGradient id='paint0_linear_topleft' x1='-164.006' y1='-56.6569' x2='38.3419' y2='145.69' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#64CB7E' />
        <stop offset='1' stopColor='#0CC5B9' />
      </linearGradient>
    </defs>
  </svg>
);
